module.exports = __webpack_public_path__ + "img/Eye.58ee765c.svg";